/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * WFM-Backend
 * OpenAPI spec version: 1
 */

export type InferenceMode = typeof InferenceMode[keyof typeof InferenceMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InferenceMode = {
  OFFLINE: 'OFFLINE',
  LIVE: 'LIVE',
} as const;
